export const documentTypes = [
  'Written Order/Prescription from Treating Practitioner',
  'Face Sheet/Demographic Information',
  'Clinical Documentation',
  'Face-to-Face Encounter',
  'History and Physical (H&P)',
  'Specialty Evaluation',
  'Patient Summary Report',
  'Therapy Notes',
  'Home Health Visit Notes',
  'Facility Discharge Summary',
  'Additional Information',
  'Product Proof of Delivery',
  'Manufacturer MSRP Sheet',
  'Manufacturer Invoice',
  'POA/AOR',
  'Duplicate',
  'PSCCR',
  'Provider Appeal',
  'Member Appeal',
  'Denial Notification',
  'Notification Proof of Delivery',
  'Other (provide the details in the description)',
];

export const documentTypeDisplayNameMap = {
  'DenialNotification' : 'Denial Notification',
  'AdditionalInformation' : 'Additional Information',
};
